// src/pages/LoginUser.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logoCongelcam from "../assets/congelcam-logo.png";
import { loginUser } from "../services/authService"; 

export default function LoginUser() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const data = await loginUser(email, password);
      // Stockage des tokens
      localStorage.setItem("access", data.access);
      localStorage.setItem("refresh", data.refresh);
      localStorage.setItem("role", "user"); 

      console.log("Connexion réussie Utilisateur :", data);
      // ✅ Redirection vers le dashboard utilisateur
      navigate("/dashboard-user");
    } catch (err) {
      console.error("Erreur de connexion :", err);
      setError("Email ou mot de passe incorrect");
    }
  };

  return (
    <div className="login-container">
      {/* Logo centré */}
      <img src={logoCongelcam} alt="Logo Congelcam" className="logo-congelcam" />

      <h1 className="login-title">Connexion Utilisateur</h1>
      <form onSubmit={handleSubmit} className="login-form">
        <input
          type="email"
          placeholder="Adresse email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="login-button">
          Se connecter
        </button>
      </form>

      {error && <p className="error-message">{error}</p>}
    </div>
  );
}
